import type { RoutineRunnerState } from '@sb/routine-runner';
import { useRobotState, useSharedFeatureFlag } from '@sbrc/hooks';

function selectEffective(state: RoutineRunnerState | null): boolean | null {
  return state?.kinematicState?.controlSourceManagerActive ?? null;
}

/**
 * True while the shared control-source-manager flag differs from the value
 * botman is running with. Botman reads flags once at boot and is the only
 * on-robot reader that lags, so this is exactly "a restart is still needed".
 * Unknown on either side reads as not pending.
 */
export function useControlSourceManagerRestartPending(): boolean {
  const flag = useSharedFeatureFlag('useControlSourceManager');

  const effective = useRobotState(
    { isVizbot: false },
    selectEffective,
    Object.is,
  );

  return flag !== null && effective !== null && flag !== effective;
}
